import React, {Component} from 'react'
import {Col, Container, Row} from "react-bootstrap";
import '@brainhubeu/react-carousel/lib/style.css';
import * as PropTypes from "prop-types";
import MainCard, {Avatar, RowInformation} from "./MainCard";
import {row} from "mathjs";

/**
 * The component that displays scouting invites.
 */
class ScoutingInvites extends MainCard {
    /**
     * Render ScoutingInvitesRow components from data object.
     * @returns {React.ReactNode} The ScoutingInvitesRow components.
     */
    renderItemsFromData = () => {
        const {data} = this.props;
        return data.map((rowData, index) =>
            <ScoutingInvitesRow key={index} name={rowData.name} description={rowData.description} avatar={rowData.avatar} datetime={rowData.datetime} detailsLink={rowData.detailsLink} badge={rowData.badge}/>
        );
    };

    wrapItemsWithContainer = (items) => {
        return (<Container fluid={true} className="scouting-invites-container"> {items} </Container>);
    };

    static propTypes = {
        // The text that will appear in the header.
        title: PropTypes.string.isRequired,
        // The text that will appear in the footer.
        footerText: PropTypes.string,
        // The link of see more page.
        footerLink: PropTypes.string,
    };
    static defaultProps = {
        title: "Scouting Invites",
        footerText: "All Invites",
        footerLink: "#"
    };
}

/**
 * The row component of ScoutingInvites.
 */
class ScoutingInvitesRow extends Component {
    render = () => {
        const {avatar, name, description, datetime, detailsText, detailsLink, badge} = this.props;
        return (
            <Row className="scouting-invites-row">
                <Col sm="auto" className="p-0">
                    <Avatar source={avatar}/>
                    {badge && <div className="badge"/>}
                </Col>

                <Col className="p-0">
                    <RowInformation title={name} description={description}/>
                </Col>

                <Col sm="auto" className="datetime-view-details-container right-side">
                    <div className="datetime-value">{datetime}</div>
                    <div className="view-details">
                        <a href={detailsLink}> {detailsText} </a>
                    </div>
                </Col>
            </Row>
        );
    };

    static propTypes = {
        // The profile image of the player.
        avatar: PropTypes.string.isRequired,
        // The name of the player.
        name: PropTypes.string.isRequired,
        // The description of the player.
        description: PropTypes.string.isRequired,
        // The data and time of the event.
        datetime: PropTypes.string.isRequired,
        // The link of player details page.
        detailsLink: PropTypes.string,
    };
    static defaultProps = {
        detailsLink: "#",
        detailsText: "View Details"
    };
}

export {ScoutingInvites, ScoutingInvitesRow};
